import { MessageCircle, Mail, MapPin, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { siteConfig, waLink } from "@/lib/siteConfig";

export default function CTAFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="bg-[#2C2621] text-[#EFEBE1] relative"
    >
      {/* Final CTA */}
      <div className="border-b border-[#4A3B2F]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
            <div className="lg:col-span-8">
              <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-[#E8B796]">
                Siap Mulai?
              </span>
              <h2
                data-testid="cta-footer-headline"
                className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-semibold text-white"
              >
                Kirim desain Anda hari ini. Kami balas cepat, hasil rapi, harga jelas.
              </h2>
            </div>
            <div className="lg:col-span-4 lg:text-right">
              <Button
                asChild
                size="lg"
                data-testid="footer-cta-whatsapp"
                className="rounded-full bg-[#C97A4E] hover:bg-[#B86A3F] text-white font-medium px-7 py-6 text-base shadow-lg transition-all duration-300 hover:-translate-y-0.5"
              >
                <a href={waLink()} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className="w-5 h-5 mr-2" />
                  Mulai via WhatsApp
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Footer info */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="font-heading text-xl font-bold text-white">
              <span className="text-[#C97A4E]">●</span> {siteConfig.brandName}
            </div>
            <p className="mt-4 font-body text-sm text-[#E5D9C5]/80 leading-relaxed">
              {siteConfig.tagline}. Bordir presisi mesin komputer untuk semua kebutuhan brand, korporat, dan personal di seluruh Indonesia.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest">
              Kontak
            </h4>
            <ul className="mt-4 space-y-3 font-body text-sm text-[#E5D9C5]/80">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#E8B796] shrink-0" />
                <a
                  href={waLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                  data-testid="footer-whatsapp-link"
                >
                  WhatsApp: +{siteConfig.whatsappNumber}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#E8B796] shrink-0" />
                <a
                  href={`mailto:${siteConfig.email}`}
                  className="hover:text-white transition-colors"
                  data-testid="footer-email-link"
                >
                  {siteConfig.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-[#E8B796] shrink-0" />
                Melayani seluruh Indonesia
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white text-sm uppercase tracking-widest">
              Navigasi
            </h4>
            <ul className="mt-4 space-y-2 font-body text-sm text-[#E5D9C5]/80">
              <li><a href="#layanan" className="hover:text-white transition-colors">Layanan</a></li>
              <li><a href="#keunggulan" className="hover:text-white transition-colors">Keunggulan</a></li>
              <li><a href="#promo" className="hover:text-white transition-colors">Promo</a></li>
              <li><a href="#proses" className="hover:text-white transition-colors">Proses Order</a></li>
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#4A3B2F] flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="font-body text-xs text-[#E5D9C5]/60">
            © {year} {siteConfig.brandName}. Semua hak dilindungi.
          </p>
          <p className="font-body text-xs text-[#E5D9C5]/60">
            Bordir Komputer · Tanpa Minimal Order · Seluruh Indonesia
          </p>
        </div>
      </div>
    </footer>
  );
}
